(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cc-collection-controls"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.cc-controls').forEach(function(form){
  form.addEventListener('submit',function(){form.querySelectorAll('input[type=number]').forEach(function(input){if(input.value==='')input.disabled=true;});});
});
  } catch(e) { console.error(e); }
})();

})();
